export default __webpack_public_path__ + "static/media/widget.6279aa7f.gif";